/* eslint-disable max-len */
import React from 'react'
import TopHeader from '../TopHeader'
export default function Emptyscreen({FirstPTag,SecondePTag,title,PatientNotes,ViewNotes,provider}) {
    return (
        <>
            <TopHeader title={title}/>
           
            <div className={`bg-white rounded-lg py-3 ${provider?'h-customh18':''} ${PatientNotes? 'mt-0 pt-0':'h-customh7 '} ${ViewNotes?'mt-14':''} px-6 flex flex-col justify-center items-center`}>
                <img src="/images/emptyscreen_img.png" alt="emptyscreen" className="mx-auto"/>
                <p id= "empty_screen" className="text-center text-xl font-normsl text-[#000]">{FirstPTag} <br />{SecondePTag}</p>
            </div>
           
        </>

       
    )
}
